import React from 'react';

const SVG = ({ style = {}, color = 'rgba(255,255,255,0.7)', width = '100%', viewBox = '0 0 100 100' }) => {
  return (
    <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5" fill={color}>
        <circle cx="50" cy="25" r="6" />
        <circle cx="68" cy="32" r="5.5" />
        <circle cx="75" cy="50" r="5" />
        <circle cx="68" cy="68" r="4.5" />
        <circle cx="50" cy="75" r="4" />
        <circle cx="32" cy="68" r="3.5" />
        <circle cx="25" cy="50" r="3" />
        <circle cx="32" cy="32" r="2.5" />
      </g>
    </svg>
  );
};

const Loader = ({ width }) => (
  <div className="loader">
    <SVG width={width} />
  </div>
);

export default Loader;
